import { jsxs as i, jsx as o } from "react/jsx-runtime";
import t from "../../icons/mail.js";
import f from "../../icons/facebook.js";
import d from "../../icons/twitter.js";
import m from "../../icons/instagram.js";
import _ from "../../icons/logo.js";
import '../../../assets/index.css';const h = "_footer_1e45k_8", e = {
  footer: h,
  "footer--info": "_footer--info_1e45k_16",
  "footer--info--nav": "_footer--info--nav_1e45k_28",
  "footer--info--nav--list": "_footer--info--nav--list_1e45k_31",
  "footer--social": "_footer--social_1e45k_38",
  "logo--leter__o": "_logo--leter__o_1e45k_42",
  "footer--info--social": "_footer--info--social_1e45k_47"
};
function k({
  addressContent: n = "Bohiio LLC, Mission, TX 78574, EE. UU.",
  logoContent: l = /* @__PURE__ */ o(_, {}),
  navLinksContent: s = [
    /* @__PURE__ */ o("span", { children: "Certifica tu propiedad" }),
    /* @__PURE__ */ o("span", { children: "Quienes Somos" }),
    /* @__PURE__ */ o("span", { children: "Preguntas frecuentes" }),
    /* @__PURE__ */ o("span", { children: "Privacidad" }),
    /* @__PURE__ */ o("span", { children: "Terminos" }),
    /* @__PURE__ */ o("span", { children: "Ayuda" }),
    /* @__PURE__ */ o("span", { children: "Español" })
  ],
  socialContent: r = /* @__PURE__ */ o("nav", { children: /* @__PURE__ */ i("ul", { children: [
    /* @__PURE__ */ o("li", { children: /* @__PURE__ */ o(t, {}) }),
    /* @__PURE__ */ o("li", { children: /* @__PURE__ */ o(f, {}) }),
    /* @__PURE__ */ o("li", { children: /* @__PURE__ */ o(d, {}) }),
    /* @__PURE__ */ o("li", { children: /* @__PURE__ */ o(m, {}) })
  ] }) })
}) {
  return /* @__PURE__ */ i("footer", { className: `${e.footer}`, children: [
    /* @__PURE__ */ i("div", { className: `${e["footer--info"]}`, children: [
      /* @__PURE__ */ o("figure", { className: "b-mb-4 md:b-mb-2", children: l }),
      /* @__PURE__ */ o("nav", { className: `${e["footer--info--nav"]} b-my-6 lg:b-my-3`, children: /* @__PURE__ */ o("ul", { className: `${e["footer--info--nav--list"]}`, children: s.map((a, c) => /* @__PURE__ */ o(
        "li",
        {
          className: `${e["footer--info--nav--list--option"]}`,
          children: a
        },
        c
      )) }) }),
      /* @__PURE__ */ o("div", { className: `${e["footer--info--social"]} b-mb-6 lg:b-mb-0`, children: r }),
      /* @__PURE__ */ o("address", { className: `${e["footer--info--address"]}`, children: n })
    ] }),
    /* @__PURE__ */ o("div", { className: `${e["footer--social"]}`, children: r })
  ] });
}
export {
  k as Footer
};
